import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { trackClick } from './tracking';
import { openChat } from '../../actions/chat';
import { EDeviceType } from '../../types/device';
import { TThunkDispatch } from '../../types/redux';
import { IFavoriteEntity } from '../../types/results';

type TOpenChatParams = {
  defaultMessage?: string;
};

interface IParams {
  offer: IFavoriteEntity;
  position: number;
  total: number;
  deviceType: EDeviceType;
}

export function useChats({ offer, position, total, deviceType }: IParams) {
  const dispatch = useDispatch<TThunkDispatch>();

  const handleOpenChat = useCallback(
    (params: TOpenChatParams | void) => {
      const { defaultMessage } = params || {};

      trackClick({ offer, position, total, deviceType });

      dispatch(openChat({ offer, position, defaultMessage }));
    },
    [dispatch, offer],
  );

  return useMemo(
    () => ({
      isEnabled: Boolean(offer.agentInfo?.isChatEnabled),
      openChat: handleOpenChat,
    }),
    [offer, handleOpenChat],
  );
}
